import React, { Component } from 'react'
import { injectIntl } from 'react-intl'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import MainCommentsTopInputv2 from "./MainCommentsTopInputv2";

export class MainCommentsTop extends Component {
  constructor(props) {
    super(props)
    this.commentRefToShow = React.createRef()
    this.scrollDiv = React.createRef()
    this.state = {
      defaultAvatar: '/images/icons/user-icon.svg',
      recommendedText: false,
      isSearching:true,
    }
  }

  componentDidMount() {
    const { avatar } = this.props

    if (avatar) {
      this.setState({
        defaultAvatar: avatar,
      })
    }
  }

  componentDidUpdate(prevProps) { }

  handleShowSearching = () => {
    this.setState({
      isSearching: true,
    })
  }

  handleHiddenSearching = () => {
    this.setState({
      isSearching: false,
    })
  }

  render() {
    // const hash = '#'
    const {
      itemSelected,
      intl,
      adminUsersToComment,
      operatorsUsersToComment,
      isFetchingUsersToComment,
      canCreateCommentDart,
      searchComments,
      saveRecommendedText,
      comment,
      recommendedText,
      userDefaultComments,
      itemsComments
    } = this.props

    const { isSearching } = this.state;
    /**MENTIONS */
    let usersMentions = []
    if (
      itemSelected &&
      !isFetchingUsersToComment &&
      (adminUsersToComment || operatorsUsersToComment)
    ) {
      if (itemSelected && adminUsersToComment) {
        adminUsersToComment.forEach((item) => {
          usersMentions.push({
            id: item._id,
            name: item.name,
            display: `${item.name} (${item.email})`,
          })
        })
      }
      if (itemSelected && operatorsUsersToComment) {
        operatorsUsersToComment.forEach((item) => {
          if (!usersMentions.find((r) => r.id === item.id)) {
            usersMentions.push({
              id: item._id,
              name: item.name,
              display: `${item.name} (${item.email})`,
            })
          }
        })
      }

      usersMentions = [
        ...usersMentions.sort((a, b) =>
          a.display.toLowerCase() < b.display.toLowerCase()
            ? -1
            : a.display.toLowerCase() > b.display.toLowerCase()
              ? 1
              : 0
        ),
      ]
    }

    return (
      <div className="bb-comments-block__top">
        <div>
          <h3>{intl.formatMessage({ id: 'comments' })}</h3>
          {isSearching ? (
            <div
              className="bb-comments-block__top-search"
              style={{ marginLeft: 15, marginTop: -38, }}
            >
              <svg
                width={15}
                height={14}
                viewBox="0 0 15 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g opacity="0.9">
                  <path
                    d="M6.09375 0C3.25078 0 0.9375 2.31328 0.9375 5.15625C0.9375 7.99922 3.25078 10.3125 6.09375 10.3125C8.93672 10.3125 11.25 7.99922 11.25 5.15625C11.25 2.31328 8.93672 0 6.09375 0ZM6.09375 9.375C3.76781 9.375 1.875 7.48266 1.875 5.15625C1.875 2.83031 3.76781 0.9375 6.09375 0.9375C8.42016 0.9375 10.3125 2.83031 10.3125 5.15625C10.3125 7.48266 8.42016 9.375 6.09375 9.375Z"
                    fill="white"
                  />
                  <path
                    d="M13.9248 12.325L11.1118 9.51246C10.9285 9.32918 10.6323 9.32918 10.449 9.51246C10.2657 9.69574 10.2657 9.99199 10.449 10.1753L13.262 12.9878C13.3534 13.0792 13.4734 13.1251 13.5934 13.1251C13.7134 13.1251 13.8334 13.0792 13.9248 12.9878C14.108 12.8045 14.108 12.5082 13.9248 12.325Z"
                    fill="white"
                  />
                </g>
              </svg>

              <input
                type="text"
                onChange={this.props.searchCommentsFilters}
                value={searchComments}
                placeholder={intl.formatMessage({
                  id: 'search_in_message',
                })}
                // onBlur={this.handleHiddenSearching}
                // autoFocus
              />
            </div>
          ) : (
            <div
              onClick={this.handleShowSearching}
              style={{ cursor: "pointer", display: 'inline', marginBottom: 20, marginLeft: 30 }}
            >
              <svg
                width={18}
                height={18}
                viewBox="0 0 15 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g opacity="0.9">
                  <path
                    d="M6.09375 0C3.25078 0 0.9375 2.31328 0.9375 5.15625C0.9375 7.99922 3.25078 10.3125 6.09375 10.3125C8.93672 10.3125 11.25 7.99922 11.25 5.15625C11.25 2.31328 8.93672 0 6.09375 0ZM6.09375 9.375C3.76781 9.375 1.875 7.48266 1.875 5.15625C1.875 2.83031 3.76781 0.9375 6.09375 0.9375C8.42016 0.9375 10.3125 2.83031 10.3125 5.15625C10.3125 7.48266 8.42016 9.375 6.09375 9.375Z"
                    fill="white"
                  />
                  <path
                    d="M13.9248 12.325L11.1118 9.51246C10.9285 9.32918 10.6323 9.32918 10.449 9.51246C10.2657 9.69574 10.2657 9.99199 10.449 10.1753L13.262 12.9878C13.3534 13.0792 13.4734 13.1251 13.5934 13.1251C13.7134 13.1251 13.8334 13.0792 13.9248 12.9878C14.108 12.8045 14.108 12.5082 13.9248 12.325Z"
                    fill="white"
                  />
                </g>
              </svg>
            </div>
          )}
        </div>
        <MainCommentsTopInputv2
          //Variables
          canCreateCommentDart={canCreateCommentDart}
          saveRecommendedText={saveRecommendedText}
          comment={comment}
          searchComments={searchComments}
          itemsComments={itemsComments}
          usersMentions={usersMentions}
          recommendedText={recommendedText}
          userDefaultComments={userDefaultComments}
          //Funciones
          handleKeyDown={this.props.handleKeyDown}
          handleCommentTextChange={this.props.handleCommentTextChange}
          onAddMention={this.props.onAddMention}
          closeRecommendedText={this.props.closeRecommendedText}
          deleteRecommendedText={this.props.deleteRecommendedText}
          selectRecommendedText={this.props.selectRecommendedText}
          showSaveRecommendedText={this.props.showSaveRecommendedText}
          showRecommendedText={this.props.showRecommendedText}
          handleSaveRecommendedText={this.props.handleSaveRecommendedText}
          handleSubmit={this.props.handleSubmit}
          addEmojiToComment={this.props.addEmojiToComment}
          focusInCurrentTarget={this.props.focusInCurrentTarget}
        />
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  const obj = {
    itemSelected: state.comments.itemSelected,
    userDefaultComments: state.comments.userDefaultComments,
    adminUsersToComment: state.comments.adminUsersToComment,
    operatorsUsersToComment: state.comments.operatorsUsersToComment,
    isFetchingUsersToComment: state.comments.isFetchingUsersToComment,
  }

  return obj
}

const mapDispatchToProps = {}

export default injectIntl(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(MainCommentsTop))
)
